var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "kpi-cards" }, [
    _c("div", { staticClass: "chart-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row g-2" },
        _vm._l(_vm.todosLosKPIs, function (kpi) {
          return _c("KPICard", {
            key: kpi.key,
            attrs: {
              value: kpi.value,
              label: kpi.label,
              subtitle: kpi.subtitle,
              icon: kpi.icon,
              "card-class": kpi.cardClass,
              tooltip: kpi.tooltip,
            },
          })
        }),
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-chart-bar text-primary" }),
      _vm._v(" Indicadores Clave\n            de Rendimiento\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }